package br.com.vvrefeicoes.portal.feature.operacional

import br.com.vvrefeicoes.portal.core.util.MoneyFormatter
import kotlin.math.abs
import kotlin.math.roundToLong

/** Valor monetário compacto para rótulos de gráfico: `R$ 1,2M`, `R$ 66k` ou `R$ 123,45`. */
internal fun compactMoney(cents: Long): String {
    val magnitude = abs(cents)
    val value =
        if (magnitude < 100_000) {
            MoneyFormatter.formatCents(magnitude)
        } else {
            compactNumber(magnitude / 100.0)
        }
    val prefix = if (cents < 0) "-R$" else "R$"
    return "$prefix $value"
}

/** Número inteiro com separador de milhar: `55.000`, `-1.500` ou `29`. */
internal fun plainNumber(value: Long): String = MoneyFormatter.formatNumber(value)

/** Número compacto para rótulos de gráfico: `1,2M`, `66k` ou `29`. */
internal fun compactNumber(value: Double): String {
    val sign = if (value < 0) "-" else ""
    val magnitude = abs(value)
    val scaled =
        when {
            magnitude >= 1_000_000.0 -> formatScaled(magnitude / 1_000_000.0, "M")
            magnitude >= 1_000.0 -> formatScaled(magnitude / 1_000.0, "k")
            else -> magnitude.roundToLong().toString()
        }
    return sign + scaled
}

private fun formatScaled(
    value: Double,
    suffix: String,
): String {
    val text =
        if (value < 10) {
            val tenths = (value * 10).roundToLong()
            "${tenths / 10},${abs(tenths % 10)}"
        } else {
            value.roundToLong().toString()
        }
    return text + suffix
}
